/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import styled from 'styled-components';

const ButtonContent = styled.div`
  align-items: flex-end;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  width: 100%;
`;

export { ButtonContent };
